/* Floor Fix Pro - adds the space-separated money formats (e.g. SEK/NOK/DKK "{{amount_with_space_separator}} kr") that theme.Currency.formatMoney is missing, so variant prices don't go blank after a pack-size click. Added 12 Oct 2026. */
(function () {
  var FORMATS = { amount_with_space_separator: [2, ' ', ','], amount_no_decimals_with_space_separator: [0, ' ', ','], amount_with_period_and_space_separator: [2, ' ', '.'], amount_with_apostrophe_separator: [2, "'", '.'] };
  var PH = /\{\{\s*(\w+)\s*\}\}/;
  function fmt(cents, p) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var n = Number(cents);
    if (isNaN(n)) return '0';
    var parts = (n / 100).toFixed(p[0]).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + p[1]);
    return parts[1] ? whole + p[2] + parts[1] : whole;
  }
  function patch() {
    var C = window.theme && window.theme.Currency;
    if (!C || typeof C.formatMoney !== 'function') return false;
    if (C.__ffpMoneyFix) return true;
    var original = C.formatMoney;
    C.formatMoney = function (cents, format) {
      var f = format || (window.theme && window.theme.moneyFormat) || '';
      var m = f.match(PH);
      if (!m || !FORMATS[m[1]]) return original.apply(this, arguments);
      return f.replace(PH, fmt(cents, FORMATS[m[1]]));
    };
    C.__ffpMoneyFix = true;
    return true;
  }
  if (!patch()) document.addEventListener('DOMContentLoaded', patch);
})();
